import * as extendActionType from '../extendActionType';

export const ADD_DOCTOR_TASK = 'doctorTasks/ADD_DOCTOR_TASK';
export const ADD_DOCTOR_TASK_DIALOG = 'doctorTasks/ADD_DOCTOR_TASK_DIALOG';
export const TASK_TO_ENCOUNTER = 'doctorTasks/TASK_TO_ENCOUNTER';
export const EDIT_DOCTOR_TASK_DIALOG = 'doctorTasks/EDIT_DOCTOR_TASK_DIALOG';
export const FETCH_DOCTOR_TASKS = 'doctorTasks/FETCH_DOCTOR_TASKS';
export const CHANGE_DOCTOR_TASKS_FILTER = 'doctorTasks/CHANGE_DOCTOR_TASKS_FILTER';
export const CLOSE_DOCTOR_TASK = 'doctorTasks/CLOSE_DOCTOR_TASK';
export const EDIT_DOCTOR_TASK = 'doctorTasks/EDIT_DOCTOR_TASKS';
export const GET_ASSIGNEES_FOR_DROPDOWN = 'doctorTasks/GET_ASSIGNEES_FOR_DROPDOWN';
export const DELETE_DOCTOR_TASK = 'doctorTasks/DELETE_DOCTOR_TASK';

export function addDoctorTask(patient, assignee, description, files) {
    return {
        type: ADD_DOCTOR_TASK,
        httpRequest: {
            method: 'post',
            path: '/doctorTasks',
            data: {
                patient,
                assignee,
                description,
                files,
            },
        },
    };
}

export function taskToEncounter(taskId, {patientId, encounterReason}) {
    return {
        type: TASK_TO_ENCOUNTER,
        httpRequest: {
            method: 'post',
            path: `/doctorTasks/encounter/${taskId}`,
            data: {
                patientId,
                encounterReason,
            },
        },
    };
}

export function deleteDoctorTask(taskId) {
    return {
        type: DELETE_DOCTOR_TASK,
        httpRequest: {
            method: 'del',
            path: `/doctorTasks/${taskId}`,
        },
        id: taskId,
    };
}

export function getAssigneesForDropdown(search) {
    return {
        type: GET_ASSIGNEES_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/doctorTasks/assignees/dropdown',
            params: {
                search,
            },
        },
    };
}

export function editDoctorTask(taskId, fields) {
    return {
        type: EDIT_DOCTOR_TASK,
        httpRequest: {
            method: 'put',
            path: `/doctorTasks/edit/${taskId}`,
            data: {
                assignee: fields.assignee.id,
                patient: fields.patient ? fields.patient.id : null,
                description: fields.description,
            },
        },
        taskId,
        fields,
    };
}

export function fetchDoctorTasks({offset, limit, filter}) {
    return {
        type: FETCH_DOCTOR_TASKS,
        httpRequest: {
            method: 'post',
            path: '/doctorTasks/list',
            data: {
                offset,
                limit,
                filter,
            },
        },
        offset,
        limit,
        filter,
    };
}

export function closeTask(taskId) {
    return {
        type: CLOSE_DOCTOR_TASK,
        httpRequest: {
            method: 'put',
            path: `/doctorTasks/close/${taskId}`,
        },
        taskId,
    };
}

export function changeDoctorTasksFilter(filter) {
    return {
        type: CHANGE_DOCTOR_TASKS_FILTER,
        filter,
    };
}

export function showAddDoctorTaskDialog(file) {
    return {
        type: extendActionType.show(ADD_DOCTOR_TASK_DIALOG),
        file,
    };
}

export function hideAddDoctorTaskDialog() {
    return {type: extendActionType.hide(ADD_DOCTOR_TASK_DIALOG)};
}

export function showEditDoctorTaskDialog(task) {
    return {
        type: extendActionType.show(EDIT_DOCTOR_TASK_DIALOG),
        task,
    };
}

export function hideEditDoctorTaskDialog() {
    return {type: extendActionType.hide(EDIT_DOCTOR_TASK_DIALOG)};
}



// WEBPACK FOOTER //
// ./src/reducers/doctorTasks/doctorTasksActions.js